<template lang="html">
    <div>
        <div class="row">
                <div class="col-md-6 col-lg-3">
                    <div class="widget-small primary coloured-icon"><i class="icon bi bi-bookmark fs-1"></i>
                        <div class="info">
                            <h4>ห้องน้ำ</h4>
                            <p><b>{{ restroomCount }}</b></p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="widget-small info coloured-icon"><i class="icon bi bi-bookmark fs-1"></i>
                        <div class="info">
                            <h4>ถังดับเพลิง</h4>
                            <p><b>{{ fireExtinguisherCount }}</b></p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="widget-small warning coloured-icon"><i class="icon bi bi-bookmark fs-1"></i>
                        <div class="info">
                            <h4>ตู้แช่ยาและเวชภัณฑ์</h4>
                            <p><b>{{ medicineCabinetCount }}</b></p>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="widget-small danger coloured-icon"><i class="icon bi bi-bookmark fs-1"></i>
                        <div class="info">
                            <h4>ห้องควบคุมอุณหภูมิ</h4>
                            <p><b>{{ roomTemperatureCount }}</b></p>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>
<script setup>
// import ChartMedicineCabinet from '@/components/ChartMedicineCabinet.vue';
// import ChartRoomTemperature from '@/components/ChartRoomTemperature.vue';
import axiosInstance from '@/utils/axiosInstance';
import { onMounted, ref } from 'vue';

const restroomCount = ref(0);
const fireExtinguisherCount = ref(0);
const medicineCabinetCount = ref(0);
const roomTemperatureCount = ref(0);

const fetchCounts = async () => {
    try {
        const [restroom, fireExtinguisher, medicineCabinet, roomTemperature] = await Promise.all([
            axiosInstance.get('/restroom'),
            axiosInstance.get('/fire_extinguisher'),
            axiosInstance.get('/medicine_cabinet'),
            axiosInstance.get('/room_temperature')
        ]);

        restroomCount.value = restroom.data.length;
        fireExtinguisherCount.value = fireExtinguisher.data.length;
        medicineCabinetCount.value = medicineCabinet.data.length;
        roomTemperatureCount.value = roomTemperature.data.length;

    } catch (error) {
        console.error('Error fetching data:', error);
    }
};

onMounted(fetchCounts);
</script>

<style lang="">
    
</style>